'use client'
import cl from 'clsx'
import DescriptionSaTool from './description'
import ResultsSaTool from './results'
import MethodsSaTool from './methods'
import styles from './styles.module.css'
import Button from "@/ui/button";
import {scrollTo} from "@/utils/scrollTo";
import { ScrollPanel } from 'primereact/scrollpanel'
import './styles.css'

export default function SaTool({select, descriptionNumber, dict}) {
    let description
    switch(descriptionNumber) {
        case 1: 
            description = <DescriptionSaTool dict={dict} />
            break
        case 2:
            description = <MethodsSaTool dict={dict} />
            break
        case 3:
            description = <ResultsSaTool dict={dict} />
            break
        default: 
            description = <div>Description 1</div>
            break
    }

    const {description_menu, methods_menu, results_menu, btn_begin} = dict.discover;
    return (
        <div className={cl(styles.discover__text_content, 'discover_sa_tool')}>
            <div>
                <div className={styles.discover__text_content_title_wrapper}>
                    <h2 onClick={() => select(1)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            descriptionNumber === 1 && styles.selected,
                            descriptionNumber !== 1 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {description_menu}
                    </h2>
                    <h2 onClick={() => select(2)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            descriptionNumber === 2 && styles.selected,
                            descriptionNumber !== 2 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {methods_menu}
                    </h2>
                    <h2 onClick={() => select(3)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            descriptionNumber === 3 && styles.selected,
                            descriptionNumber !== 3 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {results_menu}
                    </h2>
                </div>
                <div className={styles.discover__text_conten_description}>
                    <ScrollPanel style={{ width: '100%', height: '400px', }} className={"custombar2"}>
                        {description}
                    </ScrollPanel>
                </div>
            </div>
            <div className={styles.discover__btn_wrapper}>
                <Button onClick={(event) => scrollTo(event, "header", 0)} title={btn_begin} type="discover-login"/>
            </div>
        </div>
    );
}